import {DEFAULT_DATASET} from './datasets.js';
import {graneroInstance} from './index.js';

/**
 * Provides methods for working with Granero collections.
 * @module api/collections
 */

// Collections have a "slug id" that is friendly
// for users to use but causes odd edge cases
//  when using the ID as a key.
export const getCollectionId = collection => collection.id.split('-').pop();

export const getCollections = options => {
  const {dataset = DEFAULT_DATASET, ...config} = options || {};

  return graneroInstance
    .get(`/ogc/${dataset}/collections/`, config)
    .then(res => res.data);
};

export const createCollection = (collection, options) => {
  const {dataset = DEFAULT_DATASET, ...config} = options || {};

  if (!collection) {
    throw new Error('Collection object is required');
  }

  return graneroInstance
    .post(`/ogc/${dataset}/collections/`, collection, config)
    .then(res => res.data);
};

export const getCollection = (id, options) => {
  const {dataset = DEFAULT_DATASET, ...config} = options || {};

  return graneroInstance
    .get(`/ogc/${dataset}/collections/${id}/`, config)
    .then(res => res.data);
};

export const updateCollection = (collectionId, updateProps, options) => {
  const {dataset = DEFAULT_DATASET, ...config} = options || {};

  return graneroInstance
    .put(`/ogc/${dataset}/collections/${collectionId}/`, updateProps, config)
    .then(res => res.data);
};

export const deleteCollection = (collectionId, options) => {
  const {dataset = DEFAULT_DATASET, ...config} = options || {};

  return graneroInstance
    .delete(`/ogc/${dataset}/collections/${collectionId}/`, config)
    .then(res => res.data);
};

export const shareCollection = (collectionId, options) => {
  const {dataset = DEFAULT_DATASET, ...config} = options || {};

  return graneroInstance
    .post(`/ogc/${dataset}/collections/${collectionId}/permission/`, {}, config)
    .then(res => res.data);
};

export const unshareCollection = (collectionId, options) => {
  const {dataset = DEFAULT_DATASET, ...config} = options || {};

  return graneroInstance
    .delete(`/ogc/${dataset}/collections/${collectionId}/permission/`, config)
    .then(res => res.data);
};
